// @ts-strict-ignore
import type { MultiSelectProps } from '@usealloy/component-library';
import { MultiSelect } from '@usealloy/component-library';
import React, {
  forwardRef,
  useContext,
} from 'react';
import { RuleBuilderContext } from '../../context';
import { useMultiSelectKeyboardFocus } from 'flow/editor/hooks/useMultiSelectKeyboardFocus';
import { StyledRuleMultiSelect } from '../styles';
import { isEditable } from '../../helpers';

type RuleMultiSelectProps = MultiSelectProps & {
  id?: string;
  isInvalid?: boolean;
};

const RuleMultiSelect = forwardRef((
  props: RuleMultiSelectProps,
  forwardedRef,
) => {
  const { id: propsId, isDisabled, isInvalid } = props;
  const { keyboardFocus, editMode } = useContext(RuleBuilderContext);

  const { id, setInstance, onFocus } = useMultiSelectKeyboardFocus({
    keyboardFocus,
    idPrefix: 'rule-builder-multiselect',
    id: propsId,
    forwardedRef,
  });

  return (
    <StyledRuleMultiSelect isInvalid={isInvalid}>
      <MultiSelect
        {...props}
        onFocus={onFocus}
        id={id}
        ref={setInstance}
        isDisabled={isDisabled || !isEditable(editMode)}
      />
    </StyledRuleMultiSelect>
  );
});

RuleMultiSelect.displayName = 'RuleMultiSelect';

export default React.memo(RuleMultiSelect);
